module.exports = __webpack_public_path__ + "static/img/276_TO8_2406.cb33139.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/276_TO8_2406.jpg
// module id = 2R6X
// module chunks = 0